import React, { useState, useEffect } from "react";
import PageLayout from "../../layouts/PageLayout";
import { BASE_URL, CURRENT_IP, TOKEN } from "../../helper/BASE_URL";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ButtonComponent } from "../../components/elements";
import Btc from "../../assets/btc-Icon.png";
import QRCode from "qrcode";
import { useNavigate } from "react-router-dom";
import { FaCopy } from "react-icons/fa";

export default function Buy_Coin() {
  const [step, setStep] = useState("First Step");
  const [amountInDollar, setAmountInDollar] = useState(0);
  const [setselectedCoin, setSetselectedCoin] = useState("");
  const [generatedWallet, setGeneratedWallet] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [invesFinalAmount, setinvesFinalAmount] = useState(0.0);
  const [qrImgae, setQrImgae] = useState("");

  const navigate = useNavigate();

  const [getData, setGetData] = useState([
    {
      icon: "account_circle",
      trend: "attach_money",
      title: "coin price",
      variant: "green",
      number: 0.0,
      percent: 95,
    },
    {
      icon: "shopping_cart",
      trend: "trending_down",
      title: "My Directs",
      variant: "purple",
      number: 0.0,
      percent: 30,
    },
    {
      icon: "shopping_bag",
      trend: "trending_down",
      title: "total paid referrals",
      variant: "blue",
      number: 0.0,
      percent: 25,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total earnings",
      variant: "yellow",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total earnings balance",
      variant: "purple",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "account_circle",
      trend: "trending_up",
      title: "PPM Wallet",
      variant: "green",
      number: 0.0,
      percent: 95,
    },
    {
      icon: "shopping_cart",
      trend: "trending_down",
      title: "Panda 11 Wallet",
      variant: "purple",
      number: 0.0,
      percent: 30,
    },
    {
      icon: "shopping_bag",
      trend: "trending_down",
      title: "level incomes earned",
      variant: "blue",
      number: 0.0,
      percent: 25,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total coins purchase",
      variant: "yellow",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total coins usd value",
      variant: "purple",
      number: 0.0,
      percent: 45,
    },
  ]);

  const styles = {
    card: {
      border: "1px solid #fff",
      padding: "20px",
      borderRadius: "10px",
      width: "300px",
      margin: "50px auto",
      textAlign: "center",
      backgroundColor: "#333",
      color: "#fff",
    },
    input: {
      width: "80%",
      padding: "10px",
      margin: "10px 0",
      borderRadius: "5px",
      border: "1px solid #ccc",
    },
    button: {
      backgroundColor: "#555",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      marginTop: "10px",
    },
    buttonHover: {
      backgroundColor: "#777",
    },
  };

  const styles2 = {
    card: {
      border: "1px solid #fff",
      padding: "20px",
      borderRadius: "10px",
      width: "300px",
      margin: "50px auto",
      textAlign: "center",
      backgroundColor: "#333",
      color: "#fff",
    },
    select: {
      width: "100%",
      padding: "10px",
      marginBottom: "10px",
      borderRadius: "5px",
      background: "#253557",
      color: "#fff",
      // border: "1px solid #ccc",
    },
    button: {
      backgroundColor: "#555",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      marginTop: "10px",
    },
  };

  const handleSubmit = () => {
    setStep("Second Step");
  };

  const handleSubmit2 = () => {
    setIsloading(true);
    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "buy_bopc.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            crypto_typ: setselectedCoin,
            amount_usd: amountInDollar,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          setIsloading(false);

          console.log(acc.data);
          if (acc.data.code == "200") {
            setStep("Third Step");

            generateQR(acc.data.data.deposit_wallet_address);
            setGeneratedWallet(acc.data.data.deposit_wallet_address);
            setinvesFinalAmount(acc.data.data.deposit_crypto_amount);
          }
        })
        .catch((err) => {
          setIsloading(false);

          console.log(err);
        });
    } catch (error) {
      setIsloading(false);

      console.log(error);
    }
  };

  const handleSubmit3 = () => {
    setStep("Fourth Step");
  };

  const styles4 = {
    card: {
      width: "400px",
      padding: "20px",
      backgroundColor: "rgb(7 30 77)",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      color: "#fff",
      fontFamily: "poppins",
      textAlign: "center",
      margin: "50px auto",
    },
    title: {
      padding: "10px",
      borderRadius: "4px",
      marginBottom: "20px",
      textAlign: "center",
      color: "#fff",
      fontSize: "15px",
      fontWeight: 700,
      fontFamily: "poppins",
    },
    balanceText: {
      fontSize: "14px",
      marginBottom: "10px",
      color: "#ccc",
    },
    balance: {
      color: "#f1c40f",
    },
    inputContainer: {
      gap: "8px",
      display: "flex",
      alignItems: "center",
      backgroundColor: "#253557",
      marginBottom: "10px",
      borderRadius: "5px",
      overflow: "hidden",
      paddingLeft: "10px",
    },
    iconText: {
      fontSize: "0.8rem",
      fontWeight: "900",
      borderRight: "1px solid #B7B7B7",
      paddingRight: "10px",
    },
    input: {
      width: "100%",
      padding: "10px",
      // marginBottom: "20px",

      // border: "1px solid #333",
      borderRadius: "5px",
      backgroundColor: "#253557",

      color: "white",
      fontSize: "16px",
      textAlign: "right",
    },
    input2: {
      width: "100%",
      padding: "10px",
      // marginBottom: "20px",

      // border: "1px solid #333",
      borderRadius: "5px",
      backgroundColor: "#253557",

      color: "white",
      fontSize: "16px",
      textAlign: "left",
    },
    button: {
      width: "100%",
      padding: "12px",
      borderRadius: "5px",
      minHeight: "46px",
      border: "none",
      // backgroundColor: "#333",
      color: "#fff",
      fontSize: "16px",
      marginTop: 10,
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#000",
      overflowY: "auto",
      overflowX: "auto",
    },
  };

  useEffect(() => {
    getDashData();
  }, []);

  const getDashData = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);

    try {
      axios
        .post(
          BASE_URL + "get_dashboard_data.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          let Data = acc.data.data;

          setGetData([
            {
              icon: "account_circle",
              trend: "attach_money",
              title: "coin price",
              variant: "green",
              number: Data.coin_price,
              percent: 95,
            },
            {
              icon: "shopping_cart",
              trend: "trending_down",
              title: "My Directs",
              variant: "purple",
              number: Data.total_referrals,
              percent: 30,
            },
            {
              icon: "shopping_bag",
              trend: "trending_down",
              title: "total paid referrals",
              variant: "blue",
              number: Data.total_paid_referrals,
              percent: 25,
            },
            {
              icon: "hotel_class",
              trend: "trending_up",
              title: "total earnings",
              variant: "yellow",
              number: Data.total_earnings,
              percent: 45,
            },
            {
              icon: "hotel_class",
              trend: "trending_up",
              title: "total earnings balance",
              variant: "purple",
              number: Data.total_earnings_balance,
              percent: 45,
            },
            {
              icon: "account_circle",
              trend: "trending_up",
              title: "PPM Wallet",
              variant: "green",
              number: Data.total_purchase_wallet,
              percent: 95,
            },
            {
              icon: "shopping_cart",
              trend: "trending_down",
              title: "Panda 11 Wallet",
              variant: "purple",
              number: Data.total_purchase_wallet_balance,
              percent: 30,
            },
            {
              icon: "shopping_bag",
              trend: "trending_down",
              title: "level incomes earned",
              variant: "blue",
              number: Data.level_incomes_earned,
              percent: 25,
            },
            {
              icon: "hotel_class",
              trend: "trending_up",
              title: "total coins purchase",
              variant: "yellow",
              number: Data.total_coins_purchase,
              percent: 45,
            },
            {
              icon: "hotel_class",
              trend: "trending_up",
              title: "total coins usd value",
              variant: "purple",
              number: Data.total_coins_usd_value,
              percent: 45,
            },
          ]);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("COPIED ✅");
    });
  };

  const generateQR = async (text) => {
    QRCode.toDataURL(text)
      .then((url) => {
        console.log(url);
        setQrImgae(url);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleFinal = () => {
    toast.success("Status will be updated shortly");

    navigate("/Deposit");
  };

  return (
    <PageLayout
      style={{ overflowY: "auto", overflowX: "hidden", height: "80vh" }}
    >
      <ToastContainer />

      {step == "First Step" && (
        <div style={styles.container}>
          <div className="buy-coin-card">
            <h2 style={styles4.title}>Buy BOP Tokens</h2>
            <div style={styles4.inputContainer}>
              <img width={28} height={28} src="/images/usdticon.png" />
              <span style={styles4.iconText}>USD</span>
              <input
                placeholder="Enter Amount In USD"
                type="number"
                style={styles4.input}
                onChange={(e) => setAmountInDollar(e.target.value)}
              />
            </div>
            <div style={styles4.inputContainer}>
              <img width={28} height={28} src="/images/logo.png" />
              <span style={styles4.iconText}>BOP</span>
              <input
                type="text"
                style={styles4.input}
                value={amountInDollar / Number(getData[0].number)}
              />
            </div>

            <div className="d-flex justify-content-end" style={{ left: 0 }}>
              <h6 style={{ fontSize: "15px" }}>You will receive</h6>
            </div>
            {amountInDollar >= 15 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <ButtonComponent
                  handleClick={handleSubmit}
                  style={styles4.button}
                  className="mc-btn primary"
                  icon="verified"
                  text={"Confirm"}
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <ButtonComponent
                  style={styles4.button}
                  handleClick={() =>
                    toast.error("USD Value Should Be Greater Than 15")
                  }
                  className="mc-btn primary"
                  icon="verified"
                  text={"Confirm"}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {step == "Second Step" && (
        <div style={styles.container}>
          <div className="buy-coin-card">
            <h2 style={styles4.title}>Select The Currency</h2>

            <select
              onChange={(e) => setSetselectedCoin(e.target.value)}
              style={styles2.select}
            >
              <option value={null}>Choose Your Currency</option>
              {/* <option value="BNB">BINANCE (BNB-BEP2)</option> */}
              <option value="BNB.BSC">BINANCE (BNB-BSC)</option>
              <option value="ETH">ETHEREUM (ETH)</option>
              <option value="TRX">TRON (TRX)</option>
              <option value="USDT.ERC20">USDT (ERC20)</option>
              <option value="USDT.TRC20">USDT (TRC20)</option>
            </select>
            <br />

            {
              setselectedCoin ? (
                isloading ? (
                  // <button disabled style={styles4.button} >Loading...</button>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonComponent
                      disabled
                      icon="keyboard_tab"
                      style={styles4.button}
                      text={"Loading..."}
                    />
                  </div>
                ) : (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonComponent
                      icon="keyboard_tab"
                      style={styles4.button}
                      handleClick={handleSubmit2}
                      className="mc-btn primary"
                      text={"Submit"}
                    />
                  </div>
                )
              ) : (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ButtonComponent
                    disabled
                    icon="keyboard_tab"
                    style={styles4.button}
                    handleClick={handleSubmit2}
                    className="mc-btn primary"
                    text={"Submit"}
                  />
                </div>
              )
              // <button disabled style={styles4.button} >Submit</button>
            }
          </div>
        </div>
      )}

      {step == "Third Step" && (
        <>
          <div style={styles.container}>
            <div
              className="buy-coin-card1"
              style={{ overflow: "scroll", maxHeight: "75vh" }}
            >
              <h2 className="custom-width">Important Notice</h2>
              <ul style={{ lineHeight: "2" }}>
                <li>
                  1. You'll be redirected to the next screen, where you'll find
                  the wallet address and the required crypto amount.
                </li>
                <li>
                  2. The wallet address will remain valid for only 15 minutes.
                </li>
                <li>
                  3. You can scan the QR code to easily access the wallet
                  address.
                </li>
                <li>
                  4. Alternatively, you can copy the wallet address and the
                  crypto amount directly.
                </li>
                <li>
                  5. Exchange fees and network fees are not included in the
                  transaction.
                </li>
                <li>
                  6. Transferring an incorrect crypto amount may result in an
                  irreversible transaction.
                </li>
                <li>
                  7. The final USD value will be determined based on the
                  blockchain confirmation.
                </li>
              </ul>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 35,
                }}
              >
                <ButtonComponent
                  style={styles4.button}
                  handleClick={handleSubmit3}
                  className="mc-btn primary"
                  text={"Got it "}
                />
              </div>
            </div>
          </div>
        </>
      )}

      {step == "Fourth Step" && (
        <>
          <div style={styles.container}>
            <div className="buy-coin-card2">
              <h2 style={styles4.title}>Wallet Details</h2>
              {qrImgae && (
                <div style={{ textAlign: "center" }}>
                  <img src={qrImgae} style={{ width: 200, height: 200 }} />
                </div>
              )}
              <label
                style={{
                  color: "#a9a9a9",
                }}
              >
                Address
              </label>
              <div style={styles4.inputContainer}>
                <input
                  value={generatedWallet}
                  type="text"
                  style={styles4.input2}
                  aria-label="Amount (to the nearest dollar)"
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCopy(generatedWallet)}
                  >
                    <FaCopy size={25} style={{ color: "black" }} />
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-end" style={{ left: 0 }}>
                <h6 style={{ fontSize: "15px" }}>Copy</h6>
              </div>

              <div className="input-group mb-3"></div>
              <label
                style={{
                  color: "#a9a9a9",
                }}
              >
                You Need To Pay
              </label>
              <div style={styles4.inputContainer}>
                <input
                  value={`${invesFinalAmount}`}
                  type="text"
                  // className="form-control text-white"
                  style={styles4.input2}
                  aria-label="Amount (to the nearest dollar)"
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCopy(invesFinalAmount)}
                  >
                    <FaCopy size={25} style={{ color: "black" }} />
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-end" style={{ left: 0 }}>
                <h6 style={{ fontSize: "15px" }}>Copy</h6>
              </div>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <ButtonComponent
                  style={styles4.button}
                  handleClick={handleFinal}
                  icon="thumb_up"
                  className="mc-btn primary"
                  text={"Done"}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </PageLayout>
  );
}
